import { useEffect, useState } from "react"
import { useGeneralContext } from "../../../Contexts/GeneralContext/GeneralProvider"
import { useUserModalContext } from "../../../Contexts/UserModalContext/UserModalProvider"
import ListGroupStudentsAdmin from "../../../Components/SchoolAdminModalsComponents/ListData/ListGroupStudentsAdmin"
import ListGroupUsersAdmin from "../../../Components/SchoolAdminModalsComponents/ListData/ListGroupUsersAdmin"
import ListGroupStudents from "../../../Components/SharedComponents/ListData/ListGroupStudents"
import ListGroupUsers from "../../../Components/SharedComponents/ListData/ListGroupUsers"
import BackButton from "../../../Components/SharedComponents/OtherComponents/BackButton"
import LoadingInfo from "../../../Components/SharedComponents/OtherComponents/LoadingInfo"
import { FetchGetFunction } from "../../../Helpers/FetchHelpers"


function UserSeeGroupModal() {

	const { groupToSee, setGroupToSee } = useUserModalContext()
	const { user, appLocation, groupsOfUserAsGroups, schoolOfUser } = useGeneralContext()
	const [hasFailedToLoad, setHasFailedToLoad] = useState<boolean>(false)
	const isUserAdmin = user ? user.admin !== 'No' : false
	const groupId = appLocation?.itemId
	const isShowingGroupOfUrl = groupToSee.SK === groupId

	// Opening a group from a list already selects it. This covers a reload or a link, where
	// admins may be looking at a group they are not part of, so it is fetched if needed.
	useEffect(() => {
		if (isShowingGroupOfUrl || !groupId || !schoolOfUser) {
			return
		}
		setHasFailedToLoad(false)
		const groupFromList = groupsOfUserAsGroups.find((group) => group.SK === groupId)
		if (groupFromList) {
			setGroupToSee(groupFromList)
			return
		}
		let isStillWanted = true
		const url = `${process.env.REACT_APP_BACKEND_URL}/groups/${encodeURIComponent(groupId)}?school_id=${schoolOfUser.SK}`
		FetchGetFunction(url)
			.then((group) => {
				if (!isStillWanted) {
					return
				}
				if (group?.SK) {
					setGroupToSee({ ...group, students: group.students ?? [] })
				} else {
					setHasFailedToLoad(true)
				}
			})
			.catch(() => {
				if (isStillWanted) {
					setHasFailedToLoad(true)
				}
			})
		return () => {
			isStillWanted = false
		}
	}, [isShowingGroupOfUrl, groupId, schoolOfUser, groupsOfUserAsGroups, setGroupToSee])

	if (!isShowingGroupOfUrl) {
		return hasFailedToLoad ? (
			<div className="ItemNotFoundDiv">
				<h2>No encontramos este grupo.</h2>
				<BackButton fallbackSection='GroupList' />
			</div>
		) : (
			<LoadingInfo />
		)
	}

	return (
		<>
			<BackButton fallbackSection='GroupList' />
			<h2>{groupToSee.name}</h2>
			{isUserAdmin ? (
				<>
					<ListGroupUsersAdmin/>
					<ListGroupStudentsAdmin/>
				</>
			) : (
				<>
					<ListGroupUsers/>
					<ListGroupStudents/>
				</>
			)}
		</>
	)
}

export default UserSeeGroupModal
